export const environment = {
  production: true,
  API_URL: '',
  BIGCOMMERCE_URL: 'https://bartsparts.com'
};



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/environments/environment.ts